// @ts-strict-ignore
import {ReportLayout} from 'common/report/contexts/report-layout/types';
import {generateShortcutLabel} from 'common/util/keyboard';

import {KEYBOARD_CODE_TO_KEY, REPORT_LAYOUT_TO_KEYBOARD_CODE} from './constants';

export function generateShortcutLabelForReportLayout(reportLayout: ReportLayout) {
  return generateShortcutLabel(KEYBOARD_CODE_TO_KEY.get(REPORT_LAYOUT_TO_KEYBOARD_CODE.get(reportLayout)), {
    forMarkdown: true,
  });
}
